import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Instagram } from 'lucide-react';
import { siteConfig } from '../../data/mock';
import { NAV_ITEMS, INSTAGRAM_URL, scrollToServices } from './navItems';

const MobileMenuLink = ({ item, pathname, onClose }) => {
  const navigate = useNavigate();
  if (item.isAnchor) {
    return (
      <button
        onClick={() => { scrollToServices(pathname, navigate); onClose(); }}
        className="mobile-menu-link"
        data-testid={`mobile-link-${item.label.toLowerCase()}`}
      >
        {item.label}
      </button>
    );
  }
  return (
    <Link
      to={item.path}
      onClick={onClose}
      className="mobile-menu-link"
      data-testid={`mobile-link-${item.label.toLowerCase()}`}
    >
      {item.label}
    </Link>
  );
};

export const MobileMenu = ({ isOpen, pathname, onClose }) => (
  <>
    <div
      className={`mobile-menu-overlay ${isOpen ? 'open' : ''}`}
      onClick={onClose}
      data-testid="mobile-menu-overlay"
    />
    <div className={`mobile-menu ${isOpen ? 'open' : ''}`} data-testid="mobile-menu">
      <div className="mobile-menu-content">
        <div className="mobile-menu-logo">Elina K.</div>
        <nav className="mobile-menu-nav">
          {NAV_ITEMS.map(item => (
            <MobileMenuLink key={item.path} item={item} pathname={pathname} onClose={onClose} />
          ))}
        </nav>
        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="mobile-menu-instagram"
          data-testid="mobile-instagram-link"
        >
          <Instagram className="w-5 h-5" />
          <span>{siteConfig.instagram}</span>
        </a>
      </div>
    </div>
  </>
);
